import { TrainFill30Icon } from "@vygruppen/spor-icon-react";
import { HasCancellationsIcon } from "features/CenterContent/VehicleDetails/TrainDetails/TrainComposition/TrainSummary/HasCancellationsIcon";
import {
  TrainDate,
  TrainNumbers,
} from "features/CenterContent/VehicleDetails/TrainDetails/TrainComposition/TrainSummary/styles";
import { SwedishTrainNumbers } from "features/CenterContent/VehicleDetails/TrainDetails/TrainComposition/TrainSummary/SwedishTrainNumbers";
import { TrainRoute } from "features/CenterContent/VehicleDetails/TrainDetails/useTrainRoute";
import { Flex, HStack, Text, VStack } from "shared/components/Spor";
import { formatDateString, formatTimeString } from "shared/utils/dateTimeUtils";
import styled from "styled-components";

type TrainSummaryProps = {
  train: TrainRoute;
};

export const ContentGridBreakpoint = 1250;
const RouteTimeDate = styled(Flex)`
  flex-direction: column;
  align-items: start;
  gap: 6px;
`;

export const TrainSummary = ({ train }: TrainSummaryProps) => {
  const isSwedishTrain = train.trainIdentifier.countryCode === "SE";
  const hasCancellations =
    train.cancelled !== "NOT_CANCELLED" ||
    train.stops.some((stop) => stop.cancelled !== "NOT_CANCELLED");
  return (
    <HStack>
      <VStack alignItems="start" gap="6px">
        <HStack gap="6px">
          <TrainFill30Icon />
          <TrainNumbers className="train-numbers">
            <Text fontWeight={600} variant="md">
              {train.trainId}
            </Text>
            <Text variant="md" fontWeight={200}>
              {train.lineId}
            </Text>
          </TrainNumbers>
          {hasCancellations && (
            <HasCancellationsIcon
              countryCode={train.trainIdentifier.countryCode}
            />
          )}
        </HStack>
        <RouteTimeDate>
          <Text variant="sm">
            {train.origin} - {train.destination}
          </Text>
          <Flex alignItems="center" flexWrap="wrap">
            <Text
              variant="sm"
              style={{
                display: "initial",
                marginRight: "6px",
                textDecoration:
                  train.cancelled === "CANCELLED" ? "line-through" : "none",
              }}
            >
              {formatTimeString(train.originTime)} -{" "}
              {formatTimeString(train.destinationTime)}
            </Text>
            <TrainDate>
              ({formatDateString(train.nominalDate.toString(), "dd.MM.yy")})
            </TrainDate>
          </Flex>
        </RouteTimeDate>
      </VStack>
      {isSwedishTrain && <SwedishTrainNumbers train={train} />}
    </HStack>
  );
};
